<template>
  <section class="skills">
    <div class="page-container">

      <div class="title-1-container">
        <img src="@/assets/skills/skills.png">
        <h1 class="title">{{ $t('skills.skills') }}</h1>
      </div>

      <div class="skills-container">

        <!-- Abas (tabs) à esquerda -->
        <div class="tabs-container">
          <div class="title-2-container" v-for="(tab, index) in tabs" :key="index" @click="activateTab(index)"
          :class="[tab.borderClass, { active: activeTab === index }, { [`${tab.class}-border`]: activeTab === index }]">
            <img :src="tab.icon">
            <span class="title_2">{{ tab.title }}</span>
          </div>
        </div>

        <!-- Conteúdo das abas à direita -->
        <div class="content-container">
          <div v-for="(tab, index) in tabs" :key="index">
            <transition mode="out-in">
              <div v-if="activeTab === index" class="fade-container">
                <div class="border">
                  <div class="skill-container" :class="tab.class" v-for="(text, idx) in tab.skills" :key="idx">
                    <span class="skill-name"> {{ text.text }}</span>
                    <img :src="require(`@/assets/skills/${text.icon}`)">
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>


<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import SkillsCoding from '@/components/Helpers/Skills/SkillsCoding.js';
import SkillsGameEngine from '@/components/Helpers/Skills/SkillsGameEngine.js';
import SkillsDesign from '@/components/Helpers/Skills/SkillsDesign.js';
import Skills3d from '@/components/Helpers/Skills/Skills3d.js';
import SkillsSoftware from '@/components/Helpers/Skills/SkillsSoftware.js';
import SkillsOffice from '@/components/Helpers/Skills/SkillsOffice.js';

const activeTab = ref(0);
let interval = null;

const tabs = [
  { title: 'Coding', icon: require('@/assets/skills/coding.png'), skills: SkillsCoding, class: 'coding' },
  { title: 'Game Engines', icon: require('@/assets/skills/game_engine.png'), skills: SkillsGameEngine, class: 'game-engine' },
  { title: 'Design', icon: require('@/assets/skills/design.png'), skills: SkillsDesign, class: 'design' },
  { title: '3D', icon: require('@/assets/skills/3d.png'), skills: Skills3d, class: '_3d' },
  { title: 'Software', icon: require('@/assets/skills/software.png'), skills: SkillsSoftware, class: 'software' },
  { title: 'Office', icon: require('@/assets/skills/office.png'), skills: SkillsOffice, class: 'office' }
];

function activateTab(index) {
  activeTab.value = index;
  restartInterval();  // Reset the interval when a tab is clicked
}

function startInterval() {
  interval = setInterval(() => {
    activeTab.value = (activeTab.value + 1) % tabs.length;
  }, 2000); // 2000 ms = 2 seconds
}

function restartInterval() {
  if (interval) 
    clearInterval(interval);
  startInterval();
}

onMounted(() => {
  startInterval();
});

onUnmounted(() => {
  if (interval) 
    clearInterval(interval);
});
</script>

<style scoped>

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.content-container {
  width: 80%;
  padding: 20px;
  position: relative;
}

.fade-container {
  position: absolute;
  width: 100%;
  top: 0;
  left: 1vw;
  transition: opacity 0.5s ease-in-out;
}
.title-1-container {
  margin-top: 35px;
  font-size: 46px;
  margin-left: 10px;
}

.skills {
  display: flex;
  justify-content: center;
  background-color: #212121;
  margin-left: -8px;
  margin-right: -8px;
  margin-bottom: -10px;
  padding-bottom: 50px;
}

.skills-container {
  display: flex;
  width: 100%;
  max-width: 1200px;
}

.title-1-container {
  display: flex;
  margin-top: 35px;
}

.title {
  font-family: 'Poppins-Bold';
  color: white;
  font-size: 46px;
  margin-left: 10px;
}

.page-container {
  width: 100%;
  max-width: 1200px;
  margin-left: 8%;
  margin-right: 8%;
}

.tabs-container {
  width: 20%;
  background-color: #333;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  border-radius: 20px;
}

.title-2-container {
  display: flex;
  cursor: pointer;
  border: 3px solid rgba(255, 255, 255, 0);
  transition: ease 0.5s;
  border-radius: 10px;
}
.title-2-container:hover {
  transform: scale(1.05);
}

.title_2 {
  font-family: 'Poppins-Bold';
  color: white;
  font-size: 20px;
  margin-left: 10px;
  margin-top: 15px;
}

.title-2-container.active {
  border: 3px solid #2e76fc;
  border-radius: 10px;
  transform: scale(1.1);
}
.coding-border.active {
  border: 3px solid #48349E;
}

.game-engine-border.active {
  border: 3px solid #9A6237;
}

.design-border.active {
  border: 3px solid #386CCD;
}

._3d-border.active {
  border: 3px solid #616B7D;
}

.software-border.active {
  border: 3px solid #8B6A23;
}

.office-border.active {
  border: 3px solid #6483BD;
}

.content-container {
  width: 80%;
  padding: 20px;
}

.fade-in {
  opacity: 1;
  transition: 0.5s ease-in-out;
}

.fade-out {
  opacity: 0;
}

.border {
  border: 3px solid white;
  padding: 10px;
  display: flex;
  border-radius: 20px;
  margin-bottom: 20px;
  width: 100%;

  flex-wrap: wrap;
  gap: 10px;
  box-sizing: border-box;
}

.skill-container {
  background-color: #48349E;
  padding: 10px;
  border-radius: 20px;
  white-space: nowrap;
  margin: 1%;
  max-width: fit-content;
}

.item {
  background-color: #48349E;
  color: white;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  flex: 0 0 auto;
  max-width: calc(33.33% - 10px);
  width: auto;
}

.skill-name {
  font-family: 'Poppins-Bold';
  color: white;
  font-size: 20px;
  text-align: justify;
  margin-right: 5px;
}

.coding {
  background-color: #48349E;
}

.game-engine {
  background-color: #9A6237;
}

.design {
  background-color: #386CCD;
}

._3d {
  background-color: #616B7D;
}

.software {
  background-color: #8B6A23;
}

.office {
  background-color: #6483BD;
}

img {
  align-self: center;
}

@media(max-width: 1200px) {

  .proficiency-container {
    margin-left: 8%;
    margin-right: 8%;
  }

  .tabs-container {
    width: 50%;
  }

  .title {
    font-size: 40px;
  }
}
</style>